/** État initial aligné sur ReservationForm (app mobile) + champs wizard web existants */

export function createEmptyChambre() {
  return {
    nom: "",
    articles: { grande: "0", moyen: "0", petit: "0" },
    photos: { grande: [], moyen: [], petit: [] },
  }
}

export function getEmptyClientDevisForm() {
  return {
    serviceType: "",
    cuisine: { grande: "", moyen: "", petit: "" },
    cuisinePhotos: { grande: [], moyen: [], petit: [] },
    chambres: [createEmptyChambre()],
    notes: "",
    articleTransport: "",
    moverServiceMode: "camion_seul",
    propertyType: "maison",
    floor: "",
    hasElevator: false,
    heure: "09:00",
    colis: { S: 0, M: 0, L: 0, XL: 0, XXL: 0 },
    manutention: false,
    typeLogement: "maison",
    etage: "",
    ascenseur: false,
    depart: "",
    arrivee: "",
    coordonnees: { depart: null, arrivee: null },
    date: "",
    timeSlot: "",
    commentaires: "",
    description: "",
    typeLogementDemenagement: "maison",
    etageDemenagement: "",
    ascenseurDemenagement: false,
    services: {
      emballage: false,
      montage: false,
      garde_meuble: false,
      cartons: false,
    },
    volume: "",
    truckType: "",
    urgence: false,
    flexibleDate: false,
    contactPreference: "phone",
    newsletter: false,
    estimatedDuration: 0,
    accessDifficulty: "normal",
    specialItems: [],
    insurance: "basic",
  }
}

export function coordsLeafletToPayload(c) {
  if (!c || typeof c.lat !== "number" || typeof c.lng !== "number") return null
  return { latitude: c.lat, longitude: c.lng }
}

/** date: YYYY-MM-DD (input date), heure: HH:mm */
export function toScheduledDateIso(dateStr, heureStr) {
  if (!dateStr) {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    d.setHours(9, 0, 0, 0)
    return d.toISOString()
  }
  const m = String(heureStr || "09:00").trim().match(/^(\d{1,2}):(\d{2})/)
  const hh = m ? Math.min(23, Math.max(0, parseInt(m[1], 10))) : 9
  const mm = m ? Math.min(59, Math.max(0, parseInt(m[2], 10))) : 0
  const d = new Date(`${dateStr}T${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}:00`)
  if (isNaN(d.getTime())) {
    const fallback = new Date()
    fallback.setDate(fallback.getDate() + 1)
    fallback.setHours(9, 0, 0, 0)
    return fallback.toISOString()
  }
  return d.toISOString()
}

const SIZES = ["grande", "moyen", "petit"]

/** Retourne un message d’erreur ou null si OK (même règles que l’app mobile) */
export function validateDemenagementPhotoCounts(form) {
  const cuisine = form.cuisine || {}
  const cuisinePhotos = form.cuisinePhotos || { grande: [], moyen: [], petit: [] }
  for (const size of SIZES) {
    const count = parseInt(String(cuisine[size] || "0"), 10) || 0
    const photoCount = (cuisinePhotos[size] || []).length
    if (count > 0 && photoCount !== count) {
      return `Cuisine (${labelSize(size)}) : ${photoCount}/${count} photo(s) requise(s).`
    }
  }
  const chambres = Array.isArray(form.chambres) ? form.chambres : []
  for (let i = 0; i < chambres.length; i++) {
    const ch = chambres[i]
    const roomLabel = ch.nom?.trim() || `Pièce ${i + 1}`
    for (const size of SIZES) {
      const count = parseInt(String(ch.articles?.[size] || "0"), 10) || 0
      const photoCount = (ch.photos?.[size] || []).length
      if (count > 0 && photoCount !== count) {
        return `${roomLabel} (${labelSize(size)}) : ${photoCount}/${count} photo(s) requise(s).`
      }
    }
  }
  return null
}

function labelSize(size) {
  if (size === "grande") return "Grand"
  if (size === "moyen") return "Moyen"
  return "Petit"
}

/** Payload POST /api/service-requests/create (aligné AccueilScreen.handleReservationSubmit) */
export function buildServiceRequestBody(form, demenageurId) {
  const isAvec = form.moverServiceMode === "avec_travailleurs"
  const isAppart = isAvec && form.propertyType === "appartement"
  return {
    demenageurId,
    serviceType: form.serviceType,
    departureAddress: form.depart,
    destinationAddress: form.arrivee,
    departureCoordinates: coordsLeafletToPayload(form.coordonnees?.depart),
    destinationCoordinates: coordsLeafletToPayload(form.coordonnees?.arrivee),
    scheduledDate: toScheduledDateIso(form.date, form.heure),
    serviceDetails: {
      cuisine: form.cuisine,
      cuisinePhotos: form.cuisinePhotos || { grande: [], moyen: [], petit: [] },
      chambres: form.chambres,
      serviceType: form.moverServiceMode,
      propertyType: form.propertyType,
      floor: isAppart ? form.floor : "",
      hasElevator: isAppart ? !!form.hasElevator : false,
      notes: form.notes || "",
      article: form.articleTransport || "",
      ...(form.serviceType === "demenagement" && form.services
        ? { webSupplementalServices: form.services }
        : {}),
    },
  }
}

/** Texte / JSON pour createQuote quand pas d’endpoint service-request */
export function buildStructuredQuoteDescription(form) {
  try {
    return JSON.stringify({
      source: "web_client_devis",
      serviceType: form.serviceType,
      cuisine: form.cuisine,
      cuisinePhotos: form.cuisinePhotos,
      chambres: form.chambres,
      moverServiceMode: form.moverServiceMode,
      propertyType: form.propertyType,
      floor: form.floor,
      hasElevator: form.hasElevator,
      notes: form.notes,
      article: form.articleTransport,
      webSupplementalServices: form.serviceType === "demenagement" ? form.services : undefined,
    })
  } catch {
    return form.notes || form.articleTransport || ""
  }
}
